/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import IssuesList from '@/components/IssuesList/index.vue';
import {IssueFilterInterface, IssueInterface, IssuesConfigInterface} from '@/store/modules/issues/types';
import {Action, Getter, State} from 'vuex-class';
import {GamesStateInterface} from '@/store/modules/games/types';
import {FormStateInterface, ReportStageInterface} from '@/store/modules/form/types';
import ContentBlock from '@/components/ContentBlock/index.vue';
import {mixins} from 'vue-class-component';
import Loading from '@/components/Loading/index.vue';
import Scroller from '@/mixins/Scroller';
import {LoadingState, LoadingStateInterface} from '@/components/Loading/types';

/**
 * Report Stage 2.Check component.
 *
 */
@Component({
    name: 'c-report-stage-check',
    components: {
        'c-loading': Loading,
        'c-issues-list': IssuesList,
        'c-content-block': ContentBlock,
    },
})
export default class ReportStageCheck  extends mixins(Scroller) {
    // Forms
    @State('formStateModule') public formState!: FormStateInterface;
    @Action('cancelReportIssue', {namespace: 'formStateModule'}) public cancelReportIssue!: () => void;
    @Action('updateStage', {namespace: 'formStateModule'}) public updateStage!: (stage: number) => void;

    // GamesNavigation
    @State('gamesStateModule') public gamesState!: GamesStateInterface;
    @Action('fetchGames', {namespace: 'gamesStateModule'}) public fetchGames: any;
    // Display the problem title user entered at the previous step
    @Action('updateReportStage', {namespace: 'formStateModule'})
    public updateReportStage!: (report: ReportStageInterface) => void;
    @Action('fetchIssues', {namespace: 'issuesStateModule'})
    public fetchIssues!: (issuesConfig: IssuesConfigInterface) => Promise<void>;
    // Search Issues
    @Action('search', {namespace: 'searchStateModule'}) public search: any;
    @Getter('getSearchResults', {namespace: 'searchStateModule'}) public getSearchResults!: any;

    public issues: IssueInterface[] = [];
    public state: LoadingStateInterface = new LoadingState(false, false);
    public problem: any = '';
    public filter: IssueFilterInterface = {};
    public debounceInput: Debounce = this.$debounce(this.updateFormValues, 500);

    /**
     * Mounted lifecycle event.
     */
    public mounted(): void {
        // add ?step=2 to the url so browser back button can go back to step 1
        history.pushState({page: 2}, 'Check', '?step=2');
        Vue.nextTick(() => {
            this.scrollTop();
        });
        this.problem = this.formState.reportStage.problemTitle;

        window.onpopstate = (
            (event: PopStateEvent): void => {
                const nextPage: number = event.state.page;
                if (nextPage === this.formState.stage - 1) {
                    this.previous();
                }
            });
    }

    /**
     *  Progress to the next step if form values are valid.
     *
     */
    public next(): void {
        this.updateStage(this.formState.stage + 1);
    }

    /**
     *  Progress to the next step if form values are valid.
     *
     */
    public previous(): void {
        this.updateStage(this.formState.stage - 1);
    }

    /**
     * Update the state and ensure select fields have valid options set
     *
     * @return {Promise<void>}
     */
    public async updateFormValues(): Promise<void> {
        this.updateReportStage({
            problemTitle: this.problem,
        });
    }

}
